import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RootState } from '@/src/store'
import { getVisaBookings} from '@/src/api/services/visaService'
import {
    DashboardBookingState,
    VisaBookingDTO
} from '@/src/types/visa/dashboardBooking'

const initialState: DashboardBookingState = {
    data: null,
    isLoading: true,
    error: null
}

export const fetchDashboardBooking = createAsyncThunk(
    'dashboardBooking/fetchDashboardBooking',
    async (itineraryId: string, { rejectWithValue }) => {
        try {
            const response = await getVisaBookings(itineraryId)
            return response
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

const dashboardBookingSlice = createSlice({
    name: 'dashboardBooking',
    initialState,
    reducers: {
        resetDashboardBooking: (state) => {
            state.data = null
            state.isLoading = true
            state.error = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDashboardBooking.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDashboardBooking.fulfilled, (state, action) => {
                state.isLoading = false
                // @ts-ignore
                state.data = action.payload
            })
            .addCase(fetchDashboardBooking.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error
            })
    }
})

export const { resetDashboardBooking } = dashboardBookingSlice.actions
export const getDashboardBooking = (state: RootState) => state.dashboardBooking

export default dashboardBookingSlice.reducer
